import { PropsWithChildren } from 'react';

import { FcWithFlag } from '@hh.ru/magritte-types';
import { useBreakpoint } from '@hh.ru/magritte-ui-breakpoint';
import { NavigationBarComponent } from '@hh.ru/magritte-ui-navigation-bar/NavigationBarComponent';
import { NavigationBarProps } from '@hh.ru/magritte-ui-navigation-bar/types';

export const NavigationBar: FcWithFlag<PropsWithChildren<NavigationBarProps>, 'isNavigationBar'> = ({
    children,
    ...props
}) => {
    const { isMobile } = useBreakpoint();

    if (!isMobile) {
        return <>{children}</>;
    }

    return (
        <>
            <NavigationBarComponent {...props} inLayer />
            {children}
        </>
    );
};

NavigationBar.isNavigationBar = true;
